import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/survey-loading")({
  validateSearch: devSearchSchemaFor("survey-loading"),
  component: lazyRouteComponent(
    () => import("@/modules/session-survey/dev/SurveyLoadingPreview"),
    "SurveyLoadingPreview",
  ),
});
